import React from "react"
import { Switch, Route, Redirect, useRouteMatch } from "react-router-dom"

import { Users } from "./Users"

export const UsersIndex = () => {
  let { path } = useRouteMatch()

  return (
    <Switch>
      <Route exact path={path}>
        <Users />
      </Route>
      <Route>
        <Redirect to={path} />
      </Route>
    </Switch>
  )
}
